import { localContentPrefix } from '../../../../config';
import { http } from '../../../axios';
import { GenreCategoryOut } from '../../../../store/apiLibx';

const url = `${localContentPrefix}/v1/localcontent/genres/categories`;
export function fetchLocalContentGenreCategories(fiction: boolean) {
    const params = { fiction };
    return http.get<GenreCategoryOut>(url, { params }).then(response => response.data);
}
